import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNotification } from '@ipc/ipc-components';
import {
 SUCCESS, WARNING, ERROR, INFO,
} from './NotificationTypes';

export const NotificationsAdapter = ({ notification }) => {
  const [{
    infoNotification, warningNotification, errorNotification, successNotification,
  }] = useNotification();
  useEffect(() => {
    if (notification) {
      switch (notification.type) {
        case SUCCESS:
          successNotification(notification.message, notification.duration);
          break;
        case ERROR:
          errorNotification(notification.message, notification.duration);
          break;
        case WARNING:
          warningNotification(notification.message, notification.duration);
          break;
        case INFO:
          infoNotification(notification.message, notification.duration);
          break;
        default: {
          infoNotification(notification.message, notification.duration);
        }
      }
    }
  }, [notification]);

  return null;
};

NotificationsAdapter.propTypes = {
  notification: PropTypes.shape({
    type: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    duration: PropTypes.number,
  }),
};
